import { useState, useEffect } from "react";
import { trackAB } from "@/lib/api";

export function stickyVariant(experiment, variants) {
  const key = `gm_ab_${experiment}`;
  let v = null;
  try {
    v = localStorage.getItem(key);
  } catch (_) {}
  if (!v || !variants.includes(v)) {
    v = variants[Math.floor(Math.random() * variants.length)];
    try {
      localStorage.setItem(key, v);
    } catch (_) {}
  }
  return v;
}

/**
 * Lightweight A/B test. Randomly assigns a sticky variant per browser,
 * records an impression on mount, and exposes convert() for the goal event.
 */
export function useABTest(experiment, variants) {
  const key = `gm_ab_${experiment}`;
  const [variant] = useState(() => {
    let v = null;
    try {
      v = localStorage.getItem(key);
    } catch (_) {}
    if (!v || !variants.includes(v)) {
      v = variants[Math.floor(Math.random() * variants.length)];
      try {
        localStorage.setItem(key, v);
      } catch (_) {}
    }
    return v;
  });

  useEffect(() => {
    trackAB(experiment, variant, "impression");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convert = () => trackAB(experiment, variant, "conversion");
  return { variant, convert };
}
